var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('Table',{attrs:{"stripe":"","data":_vm.list,"columns":_vm.columns,"height":"450"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }